module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/72274ca26f833068c02a472e0411ddbf.png";